import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { Header } from "@tanstack/react-table";
import { Pin, PinOff } from "lucide-react";
import { useCallback } from "react";
import { useDataTableOptions } from "../hooks/useDataTableOptions";

interface PinColumnButtonProps<TData> {
  header: Header<TData, unknown>;
  className?: string;
}

export default function PinColumnButton<TData>({
  header,
  className,
}: PinColumnButtonProps<TData>) {
  const options = useDataTableOptions();
  const onClick = useCallback(() => {
    header.column.pin(header.column.getIsPinned() ? false : "left");
  }, [header.column]);

  if (!header.column.getCanPin()) {
    return null;
  }

  const defaultClassName = "hover:text-slate-900";
  const pinnedClassName = "text-slate-800 hover:text-slate-900";
  const sortedClassName = "hover:text-blue-900";

  const sortedOrFiltered = options.isFilteredOrSorted(header.column.id);

  return (
    <Button
      variant="ghost"
      size="icon"
      className={cn(
        "p-0 w-6 h-6 bg-transparent hover:bg-transparent",
        className,
        {
          [defaultClassName]: !header.column.getIsPinned(),
          [pinnedClassName]: header.column.getIsPinned(),
          [sortedClassName]: sortedOrFiltered !== false,
        },
      )}
      onClick={onClick}
      data-testid="pin-column-button"
    >
      {header.column.getIsPinned() ? (
        <PinOff className="w-4 h-4" />
      ) : (
        <Pin className="w-4 h-4" />
      )}
    </Button>
  );
}
